export default "__VITE_ASSET__CD934jwO__"